const moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(606), __webpack_require__.e(296), __webpack_require__.e(682), __webpack_require__.e(481), __webpack_require__.e(551), __webpack_require__.e(203), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(253), __webpack_require__.e(724), __webpack_require__.e(962), __webpack_require__.e(2), __webpack_require__.e(268), __webpack_require__.e(610), __webpack_require__.e(284), __webpack_require__.e(955)]).then(() => (() => ((__webpack_require__(35033)))));
	},
	"./Compare": () => {
		return Promise.all([__webpack_require__.e(606), __webpack_require__.e(296), __webpack_require__.e(682), __webpack_require__.e(481), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(253), __webpack_require__.e(724), __webpack_require__.e(962), __webpack_require__.e(268), __webpack_require__.e(891)]).then(() => (() => ((__webpack_require__(71891)))));
	},
	"./Detail": () => {
		return Promise.all([__webpack_require__.e(606), __webpack_require__.e(296), __webpack_require__.e(682), __webpack_require__.e(481), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(253), __webpack_require__.e(724), __webpack_require__.e(962), __webpack_require__.e(610), __webpack_require__.e(690)]).then(() => (() => ((__webpack_require__(84213)))));
	},
	"./SimpleScreener": () => {
		return Promise.all([__webpack_require__.e(606), __webpack_require__.e(296), __webpack_require__.e(682), __webpack_require__.e(481), __webpack_require__.e(551), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(253), __webpack_require__.e(724), __webpack_require__.e(2), __webpack_require__.e(602)]).then(() => (() => ((__webpack_require__(38602)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});